import { useGetParkingSharingAvailability } from '_api/useParkingSharing';
import { BookingSharingAvailability, BookingSharingRequest } from 'types/BookingSharing';

const useGetAssignedParkingAvailability = (
    availabilityId:
        | Exclude<
              BookingSharingRequest,
              {
                  status: 'requested';
              }
          >['assigned_availability_id']
        | null,
): BookingSharingAvailability | null => {
    const { data } = useGetParkingSharingAvailability(availabilityId ?? '');
    if (!availabilityId) {
        return null;
    }
    if (data && 'status' in data && data.status === 'deleted') {
        return null;
    }
    return data && !('status' in data) ? data : null;
};

export default useGetAssignedParkingAvailability;
